<template>
  <div class="page-content">
      <i class="under-development"/>
      <div class="text">正在开发中</div>
  </div>
</template>

<script>
export default {
  name: 'UnderDevelopment',
}
</script>

<style lang="less" scoped>
  .page-content{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .text {
          height: 18px;
          font-size: 18px;
          color: #8d96b3;
          line-height: 18px;
          letter-spacing: 1px;
          margin-top: 42px;
      }
  }
</style>

<style lang="less"></style>
